const appLinkSchema = {
  ChoiceField: {
    type: 'ChoiceField',
    key: 'ccc3',
    label: 'Link an App',
    description: null,
    required: false,
    disabled: false,
    hidden: false,
    data_name: 'app_id',
    default_value: null,
    visible_conditions_type: null,
    visible_conditions_behavior: 'clear',
    visible_conditions: null,
    required_conditions_type: null,
    required_conditions: null,
    multiple: false,
    allow_other: false,
    default_previous_value: false,
    choices: [],
    choice_values: [],
  },
  RecordLinkField: {
    type: 'RecordLinkField',
    key: 'ccc2',
    label: 'Linked Record',
    description: null,
    required: false,
    disabled: false,
    hidden: false,
    data_name: 'app_linked_records',
    default_value: null,
    visible_conditions_type: null,
    visible_conditions_behavior: 'clear',
    visible_conditions: null,
    required_conditions_type: null,
    required_conditions: null,
    allow_creating_records: true,
    allow_existing_records: true,
    allow_updating_records: false,
    allow_multiple_records: true,
    form_id: null,
    record_conditions_type: null,
    record_conditions: null,
    record_defaults: null,
    default_previous_value: false,
  },
};
export default appLinkSchema;
